var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.574258 13.0104L12.6138 1.30589C13.3797 0.560961 14.6214 0.560961 15.3869 1.30589C16.1524 2.05016 16.1524 3.25729 15.3869 4.0015L4.73374 14.3582L15.3866 24.7145C16.1521 25.459 16.1521 26.6661 15.3866 27.4103C14.621 28.1549 13.3794 28.1549 12.6135 27.4103L0.573948 15.7057C0.191172 15.3334 0 14.8459 0 14.3582C0 13.8703 0.191544 13.3825 0.574258 13.0104Z",
    fill: "#956D84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowL);
export default __webpack_public_path__ + "static/media/arrowL.e08a75d92f0cef782b0a149741e30a7a.svg";
export { ForwardRef as ReactComponent };